export enum MobileUploadErrorCode {
  Consumed = "Consumed",
  /** Expired or never existed. The TTL index deletes expired tokens, so these are indistinguishable. */
  Gone = "Gone",
  Limit = "Limit",
}
